export default __webpack_public_path__ + "static/media/farmacia2.1bee68b1.svg";